import React, { useEffect, useState } from "react";
import { useGameStore } from "../../store/useGameStore";

// Regular games iframe (old frontend GameContext.js style)
const GameIframe = () => {
  const iframeUrl = useGameStore((s) => s.iframeUrl);
  const isSports = useGameStore((s) => s.isSports);
  const closeGame = useGameStore((s) => s.closeGame);
  const [showIframeLoading, setShowIframeLoading] = useState(false);

  useEffect(() => {
    if (iframeUrl && !isSports) {
      setShowIframeLoading(true);
    }
  }, [iframeUrl, isSports]);

  // Don't render for sports — SportsIframe handles that
  if (!iframeUrl || isSports) return null;

  const handleBack = () => {
    closeGame();
  };

  const handleIframeLoaded = () => {
    setShowIframeLoading(false);
  };

  return (
    <div style={{
      position: "fixed", top: 0, left: 0,
      width: "100%", height: "100%",
      zIndex: 999, backgroundColor: "#1b2336",
    }}>
      {showIframeLoading && (
        <img
          src="/assets/logo.png"
          alt="Loading"
          style={{
            position: "absolute", top: "50%", left: "50%",
            transform: "translate(-50%, -50%)", width: 250,
          }}
        />
      )}
      <iframe
        src={iframeUrl}
        title="Game Iframe"
        onLoad={handleIframeLoaded}
        style={{
          width: "100%", height: "100%", border: "none",
          display: showIframeLoading ? "none" : "block",
        }}
        allowFullScreen
      />
      <button
        onClick={handleBack}
        style={{
          position: "absolute", top: 10, left: 10, zIndex: 1000,
          background: "none", border: "none", color: "#fff",
          fontSize: 24, cursor: "pointer", padding: 8,
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24" height="24" viewBox="0 0 24 24"
          fill="none" stroke="white" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round"
        >
          <path d="M19 12H5" />
          <path d="M12 19l-7-7 7-7" />
        </svg>
      </button>
    </div>
  );
};

export default GameIframe;
